import {memo} from "react";
import {
    Comments
} from "~/components";

function ToDoFormInfo({item})
{
    return (
        <div className="form">
            <Comments type={'todo'} objectId={item.id} />
        </div>
    )
}

export default memo(ToDoFormInfo);